// GENERAL
export const SET_GENERAL = "SET_GENERAL";

// PRODUCT TYPES
export const SET_PRODUCT_TYPES = "SET_PRODUCT_TYPES";

// KPIS
export const SET_KPI = "SET_KPI";
export function setKPI(payload:any) {
    return { type: SET_KPI, payload };
}